import React from "react";


const ModulePanel = ({
        title = "",
        children = {}
    })=>{
    return(
        <div className="az-content az-content-events">
            <div className="az-content-body">
                <div className="az-content-breadcrumb">
                    {title.map((obj, index)=>{
                        return <span key={index}>{obj}</span>
                    })}
                </div>

                {children}
            </div>
        </div>
    )
}

export default ModulePanel;